import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'container',
    theme => `
		position: relative;
		width: 800px;
		margin: 0 auto;
		border: 0;
		background: ${theme.color.text.white};
		box-shadow: ${theme.survey.color.gray} 0 2px 2px 0;
		overflow: hidden;

		@media all and (max-width: 960px) {
			width: 100%;
		}
	`
  ],
  [
    'content',
    `
		display: flex;
		width: 100%;
		overflow: hidden;
	`
  ]
]);
